import { Component } from '@angular/core';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { ActivatedRoute } from '@angular/router';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { HrPscType, HrEmployeeStatus } from '../../../../models';

import { PscFunctions } from '../functions/pscFunctions';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions } from '@aims/common-components';

@Component({
  selector: 'pscHrAccepted',
  templateUrl: './pscRevRecvAppQueue.component.html',
  styleUrls: ['../hr.component.css'],
  providers: [PscFunctions]
})

export class PscHrAcceptedQueueComponent {

    tablePermissions: AimsCommonTablePermissions = {
    create: false, 
    update: false, 
    delete: false,
  };
  
  defaultTableState:any = {filter:{}};
  
  pscsHeader: AimsCommonTableHeader[] = [
    { key: 'button', label: '', type: 'dynamic', filter: false, width: 75 },    
    { key: 'fullName', label: 'Name', type: AimsCommonTableHeaderType.STRING },
    { key: 'employeeStatusToId', label: 'Employee Status', type: AimsCommonTableHeaderType.DYNAMIC, filterType: 'dynamic', events: { filterAndSortCompare: (term, el) => term === el.employeeStatusToId } },
    { key: 'pscTypeId', label: 'Type', type: AimsCommonTableHeaderType.DYNAMIC, filterType: 'dynamic', events: { filterAndSortCompare: (term, el) => term === el.pscTypeId } },
    { key: 'effectiveOn', label: 'Effective', type: 'date', format: 'shortDate', width: 120 },
    { key: 'printedHr', label: 'Printed', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'wsLeadReviewedOn', label: 'WS Lead', type: AimsCommonTableHeaderType.DYNAMIC, filter: false },
    { key: 'dmApprovedOn', label: 'DM', type: AimsCommonTableHeaderType.DYNAMIC, filter: false },
    { key: 'pmmApprovedOn', label: 'PMM', type: AimsCommonTableHeaderType.DYNAMIC, filter: false },
    { key: 'hrmApprovedOn', label: 'HRM',type: AimsCommonTableHeaderType.DYNAMIC, filter: false },
    { key: 'acctReceivedOn', label: 'ACCT', type: AimsCommonTableHeaderType.DYNAMIC, filter: false },
    { key: 'itReceivedOn', label: 'IT', type: AimsCommonTableHeaderType.DYNAMIC, filter: false },
    { key: 'createdBy', label: 'Created By', type: AimsCommonTableHeaderType.STRING, filter: false },
    { key: 'createdOn', label: 'Created On', type: 'date', format: 'shortDate', width: 120, filter: false },
    { key: 'hrAuditedBy', label: 'Audited By', type: AimsCommonTableHeaderType.STRING, filter: false },
    { key: 'hrAuditedOn', label: 'Audited On', type: 'date', format: 'shortDate', width: 120, filter: false },
  ];

  constructor(private transferHttp: TransferHttpService,
    private route: ActivatedRoute,
    public permissions: PermissionsService,
    public pscFunc: PscFunctions) {
  }

  //***************************
  // Variables
  //***************************

  //UnionAffiliationId
  NO_REPRESENTATION: number = 4;

  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);

  pscTypeValues = this.transferHttp.getHot(`hr/GetPscType`);
  employeeStatusValues = this.transferHttp.getHot(`hr/GetEmployeeStatus`);

  showAllPscs: boolean = false;
  showAllDeptPscs: boolean = false;
  handleShowAllDeptPscs(){
    
  }

  //Field Values
  headerText = "Employee PSCs: Accepted and Effective in the past 30 days!";
  routedFrom = "pscHrAccepted";

  //Grid
  pscs = this.transferHttp.getHot(`hr/GetOnlyLast30DaysHrAcceptedPscs`);

  //DropDown Values
  allPscTypes: HrPscType[] = [];
  allEmployeeStatuses: HrEmployeeStatus[] = [];

  
  public handleShowAllPscs() {
    if (this.showAllPscs) {
      this.headerText = "All Employee - Accepted PSCs";
      this.pscs = this.transferHttp.getHot(`hr/GetAllHrAcceptedPscs`);
    }
    else {
      this.headerText = "Employee PSCs: Accepted and Effective in the past 30 days!";
      this.pscs = this.transferHttp.getHot(`hr/GetOnlyLast30DaysHrAcceptedPscs`);
    }
  }

  public canPmmApprove(): boolean {
    let returnVal = false;

    if (this.permissions.canUpdate(this.permissions.ComponentID.PscPmmApprovalQueue)) {
      returnVal = true;
    }
    return returnVal;
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
    this.route.params.subscribe(p => {

      this.pscTypeValues.subscribe(data => { this.allPscTypes = data; });
      this.employeeStatusValues.subscribe(data => { this.allEmployeeStatuses = data; });

    });
  }
}
